import { GraduationCap, BookOpen, Award, Shield } from "lucide-react";

export default function AboutDoctor() {
  return (
    <section id="about" data-testid="about-section" className="py-16 md:py-24 bg-clinical">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <p className="reveal text-teal font-medium text-sm uppercase tracking-widest mb-3">About the Doctor</p>
        <h2 className="reveal delay-1 font-heading font-bold text-3xl md:text-4xl text-navy tracking-tight mb-6">Meet Dr. Dileep Sunkavalli</h2>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12 mt-10">
          <div className="reveal-left lg:col-span-2 space-y-5">
            <p className="text-base md:text-lg text-slate-600 leading-relaxed">Dr. Dileep Sunkavalli is a highly skilled General, Laparoscopic, and Laser Surgeon based in Vijayawada with over a decade of surgical experience. Known for his precision, compassion, and patient-first approach, he has successfully treated thousands of patients across Andhra Pradesh.</p>
            <p className="text-base md:text-lg text-slate-600 leading-relaxed">Specialist in complex laparoscopic surgeries — Hernia, Gallbladder, Appendix — along with laser procedures for piles, fissures, and fistulas, thyroid surgery, varicose vein treatment, and a wide range of general surgical procedures.</p>
            <p className="text-base text-slate-500 leading-relaxed">Committed to delivering the highest standard of surgical care using modern techniques and technology, Dr. Dileep ensures every patient receives personalized attention and the best possible outcomes.</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
              {[
                { icon: GraduationCap, title: "MBBS", sub: "GSL Medical College" },
                { icon: BookOpen, title: "MS General Surgery", sub: "GSL Medical College" },
                { icon: Award, title: "EFIAGES", sub: "Endoscopy Fellowship in IAGES" },
                { icon: Shield, title: "FMAS, FIAGES, FALS", sub: "Fellowships & Certifications" },
              ].map((q, i) => (
                <div key={i} className={`reveal delay-${i + 1} flex gap-3 items-start`}>
                  <div className="w-10 h-10 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0"><q.icon className="w-5 h-5 text-teal" strokeWidth={1.5} /></div>
                  <div><p className="font-heading font-semibold text-navy text-sm">{q.title}</p><p className="text-slate-500 text-sm">{q.sub}</p></div>
                </div>
              ))}
            </div>
          </div>

          <div className="reveal-right space-y-6 h-fit">
            <div className="bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden">
              <img src="/images/doctor/second.webp" alt="Dr. Dileep Sunkavalli" className="w-full h-auto object-cover" loading="lazy" />
            </div>
            <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-6 space-y-5">
              <h3 className="font-heading font-semibold text-navy text-lg">Certifications & Memberships</h3>
              <ul className="space-y-3">
                {["Member of Association of Surgeons of India (ASI)","Member of Indian Association of Gastrointestinal Endo Surgeons (IAGES)","Fellowship in Minimal Access Surgery (FMAS)","Fellowship in IAGES (FIAGES)","Fellowship in Advanced Laparoscopic Surgery — Hernia (FALS)","Endoscopy Fellowship in IAGES (EFIAGES)","Published several research papers"].map((c, i) => (
                  <li key={i} className="flex gap-2 text-sm text-slate-600"><span className="w-1.5 h-1.5 rounded-full bg-teal mt-2 flex-shrink-0" />{c}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
